import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetSiteDataGqlService {
  readonly document = gql`
    query GetSiteData {
      sites {
        logo { 
          url 
          width
          height
        }
        title
        shortTitle
        keywords
        description
        robots
        backgroundImages {
          mobile_url: url(transformation: { 
            image: { 
              resize: { 
                width: 640 
              } 
            }
          })
          tablet_url: url(transformation: { 
            image: { 
              resize: {   
                width: 960 
              } 
            } 
          })
          url
        }
        copyright
        buildTools
        resources
        siteVersions
      }
    }
  `;
}
